import {Component} from 'react';
import {withRouter} from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { postMessageToParent } from '../utils';

class ScrollToTop extends Component {
	scrollToTop = false;

	componentDidMount() {
		const query = new URLSearchParams(window.location.search);
		// pokud uvedeme parametr autofocus, tak při načtení formuláře v iframu automaticky k tomuto iframu vyscrolujem
		this.scrollToTop = query.get('autofocus') !== null;
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0);
			if (this.scrollToTop) {
				postMessageToParent('scrollToTop', this.props.fixedHeaderHeight);
			}
			this.scrollToTop = true;
		}
	}

	render() {
		return null;
	}
}

export default compose(
	withRouter,
	connect((state) => ({
		fixedHeaderHeight: state.app.fixedHeaderHeight,
	})),
)(ScrollToTop);


// WEBPACK FOOTER //
// ./src/components/ScrollToTop.jsx